import React from 'react'
import { PhoneFilled } from '@ant-design/icons'
import { Header } from 'antd/es/layout/layout'
import { useNavigate } from 'react-router'
import SearchXL from '../Search/SearchXL'

export default function PublicHeaderXL ({ withSearch, styles, phoneNumber, phoneHref }) {
  const navigate = useNavigate()

  const SearchHeader = () => {
    return (
      <div className='hide-md' style={styles.search}><SearchXL onHeader={true} /></div>
    )
  }

  const AssistanceHeader = () => {
    return (
      <>
        <div className='hide-md' style={styles.largeAssistanceText}>
          <div style={styles.assistancePhone}>
            <PhoneFilled /> <a style={{ color: 'white' }} href={phoneHref}>{phoneNumber}</a>
          </div>
        </div>
        <div className='show-md' style={styles.smallAssistanceText}>
          <div style={styles.assistancePhone}>
            <PhoneFilled /><a style={{ color: 'white' }} href={phoneHref}>{phoneNumber}</a>
          </div>
        </div>
      </>
    )
  }

  return (<>
    <Header className={'header'} style={styles.header}>
      <img onClick={() => navigate('/')} style={styles.logo} className="logo" src="/images/logo-lbm-blanc.svg" alt='Logo' width="200px" />
      <div style={styles.boxText} className='hide-lower-1300'>
        <img className='hide-lower-1300' src="/images/box-exterieur.png" title="Image de la Box Médicale extérieur" width="200px" style={{ marginRight: '1em' }}/>
        Cabinet médical de téléconsultation augmentée
      </div>
      {withSearch && <SearchHeader />}
      <AssistanceHeader />

    </Header>
    <div className='show-md'><SearchXL onHeader={true} /></div>
  </>
  )
}
